const decimal = (value: number, decimals: number) => Number(value.toFixed(decimals));

type QuantityProps = {
  className?: string;
  value?: number | string;
  unit?: string;
};

const Quantity = ({ className = "", value = 0, unit = "g" }: QuantityProps) => {
  let numericValue = Number(value);

  if (isNaN(numericValue)) {
    return <span className={className}>-</span>;
  }

  if (numericValue < Number.EPSILON) {
    numericValue = 0;
  } else if (unit === "g" && numericValue < 0.001) {
    numericValue = decimal(numericValue * 1000000, 0);
    unit = "µg";
  } else if (unit === "g" && numericValue < 0.1) {
    numericValue = decimal(numericValue * 1000, 0);
    unit = "mg";
  } else if (unit === "g" && numericValue >= 1000) {
    numericValue = decimal(numericValue / 1000, 3);
    unit = "kg";
  } else if (unit === "kcal") {
    numericValue = Math.round(numericValue);
  } else {
    numericValue = decimal(numericValue, 1);
  }

  return (
    <span className={className}>
      <span className="text-black dark:text-white">{numericValue}</span>
      <span className="text-gray-500 dark:text-gray-400 ml-0.5">{unit}</span>
    </span>
  );
};

export { Quantity };
